import sessionUserReducer from './sessionUserReducer'
import openSnackbarReducer from './openSnackbarReducer'
import authorizedMenuURLReducer from './authorizedMenuURLReducer'
import QuestionariesReducer from './QuestionariesReducer'
import {
   secondaryMenuItemSelectionReducer,
   mainMenuItemSelectionReducer,
   itemWithLinkSelectionReducer
} from './MenuItemSelectionReducers'
import notificationsReducer from './notificationsReducer'
import notificationsSummaryReducer from './notificationsSummaryReducer'
import regulationsReducer from './regulationsReducer'
import regulationsSummaryReducer from './regulationsSummaryReducer'
import openSpinnerReducer from './openSpinnerReducer'
import playWelcomeTourReducer from './playWelcomeTourReducer'
import openMenuDrawerReducer from './openMenuDrawerReducer'
import userAvatarReducer from './userAvatarReducer'
import showModalReducer from './modalReducer'

export const mainReducer = (
   {
      questionaries,
      sessionUser,
      openSnackbar,
      secondaryMenuItemSelection,
      mainMenuItemSelection,
      itemWithLinkSelection,
      authorizedMenuUrlList,
      notifications,
      notificationsSummary,
      regulations,
      regulationsSummary,
      openSpinner,
      playWelcomeTour,
      openMenuDrawer,
      userAvatar,
      openModal
   },
   action
) => {
   return {
      sessionUser: sessionUserReducer(sessionUser, action),
      openSnackbar: openSnackbarReducer(openSnackbar, action),
      authorizedMenuUrlList: authorizedMenuURLReducer(
         authorizedMenuUrlList,
         action
      ),
      secondaryMenuItemSelection: secondaryMenuItemSelectionReducer(
         secondaryMenuItemSelection,
         action
      ),
      mainMenuItemSelection: mainMenuItemSelectionReducer(
         mainMenuItemSelection,
         action
      ),
      itemWithLinkSelection: itemWithLinkSelectionReducer(
         itemWithLinkSelection,
         action
      ),
      notifications: notificationsReducer(notifications, action),
      notificationsSummary: notificationsSummaryReducer(
         notificationsSummary,
         action
      ),
      regulations: regulationsReducer(regulations, action),
      regulationsSummary: regulationsSummaryReducer(regulationsSummary, action),
      openSpinner: openSpinnerReducer(openSpinner, action),
      openModal: showModalReducer(openModal, action),
      playWelcomeTour: playWelcomeTourReducer(playWelcomeTour, action),
      openMenuDrawer: openMenuDrawerReducer(openMenuDrawer, action),
      userAvatar: userAvatarReducer(userAvatar, action),
      questionaries: QuestionariesReducer(questionaries, action)
   }
}
